<div class="card" *ngIf="actualites && (actualites.length > 0 || displayAucuneActualite)">
  <div class="card-header text-left">
    <span class="badge badge-pill badge-info" *ngIf="badgeInfo">{{ badgeInfo }}</span>
  </div>
  <div class="card-body" style="padding: 0 1.25rem">
    <p-carousel [value]="actualites" [circular]="true" [autoplayInterval]="6000" [numVisible]="3">
      <ng-template let-item pTemplate="item">
        <div (click)="actualiteService.viewActu(item)" class="pointer scroll-actu">
          <div *ngIf="item.OrganismeLibelle" style="position: absolute; margin-top: -8px; margin-left: -8px">
            <span class="badge badge-pill badge-primary" style="padding: 0.4em" title="{{ item.OrganismeLibelle }}"><i class="fa fa-fw fa-superpowers"></i></span>
          </div>
          <div *ngIf="item.LogoUrl" class="text-center"><img src="{{ item.LogoUrl }}" style="max-height: 100px; max-width: 100%; padding: 10px" /><br /></div>
          <div class="libelle-actu">
            {{ item.Libelle }}
          </div>
          <table style="width: 100%">
            <tr>
              <td class="text-left">
                <span style="font-size: x-small" *ngIf="item.DebutAffichage">{{ item.DebutAffichage | date: 'dd MMMM yyyy' }}</span>
                <span style="font-size: x-small" *ngIf="!item.DebutAffichage">{{ item.Creation | date: 'dd MMMM yyyy' }}</span>
              </td>
              <!--<td class="text-right">
                <span style="font-size:x-small"><i class="fa fa-eye" aria-hidden="true"></i> {{item.CompteurVue}}</span>
              </td>-->
            </tr>
          </table>
        </div>
      </ng-template>
    </p-carousel>
    <div *ngIf="actualites.length <= 1 && displayAucuneActualite && actualitesLoaded" class="form-group row col-sm-12" style="margin-bottom: 25px">
      <span>Aucune autre actualité pour le moment</span>
    </div>
  </div>
</div>
